import { throttle, get } from 'lodash'
import VResourceList from '@/components/resources/resource-list'
import TickOrCross from '@/components/tick-or-cross'

export default {
  components: { VResourceList, TickOrCross },
  props: {
    attach: {
      type: Boolean,
      default: false,
    },
    attachTemplate: {
      type: Object,
      default: () => ({}),
    },
    filters: {
      type: Object,
      default: () => ({}),
    },
    deleteFilter: {
      type: Object,
      default: () => ({}),
    },
    resourceType: {
      type: String,
      required: true,
    },
    hidePagination: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    items() {
      return this[this.resourceType]
    },
    resourceMethod() {
      return this.resourceType.charAt(0).toUpperCase() + this.resourceType.slice(1)
    },
  },
  async mounted() {
    if (this.attachMethod) await this[this.attachMethod]({ paginate: { perPage: null } })
    await this.fetchResource()
  },
  methods: {
    get: get,
    attachResource: throttle(async function(item) {
      const attachment = { ...this.attachTemplate }
      if (!item) return this.$notify({ type: 'error', text: 'Please select an item before attempting to attaching.' })
      attachment[Object.keys(attachment).find(key => attachment[key] === null)] = item

      try {
        this.loading = true
        await this[`attach${this.resourceMethod}`](attachment)
        this.loading = false
      } catch (e) {
        this.loading = false
        this.$notify({ type: 'error', text: `Unable to attach ${item} to resource.` })
      }
    }),
    deleteResource: throttle(async function(item) {
      try {
        this.loading = true
        await this[`delete${this.resourceMethod}`](item.id || item)
        this.loading = false
      } catch (e) {
        this.loading = false
        this.$notify({ type: 'error', text: `Unable to delete resource with name ${this.resourceType}` })
      }
    }, 1000),
    fetchResource: throttle(async function(page = 1) {
      try {
        this.loading = true
        await this[`fetch${this.resourceMethod}`]({ filters: this.filters, paginate: { perPage: 10, page } })
        this.page = page
        this.loading = false
      } catch (e) {
        this.loading = false
        this.$notify({ type: 'error', text: `Unable to retrieve resource with name ${this.resourceType}` })
      }
    }, 1000),
  },
}
